// src/providers/PedidosProviders.js
import React from 'react';
import { MesaProvider } from '../contexts/controleBar/mesas/MesaContext';
import { MesaReservaProvider } from '../contexts/controleBar/mesas/MesaReservaContext';
import { ComandaProvider } from '../contexts/controleBar/comandas/ComandaContext';
import { ComandaItemProvider } from '../contexts/controleBar/comandas/ComandaItemContext';


export default function ControleBarProviders({ children }) {
  return (
    <MesaProvider>
      <MesaReservaProvider>
        <ComandaProvider>
          <ComandaItemProvider>        
            {children}
          </ComandaItemProvider>
        </ComandaProvider>
      </MesaReservaProvider>
    </MesaProvider>
  );
}
